import type { MonthYear } from '../types';

// Mois abrégés (index 0 = janvier). `month` est stocké en '1'..'12'.
export const MONTHS = [
  'Janv.',
  'Févr.',
  'Mars',
  'Avr.',
  'Mai',
  'Juin',
  'Juil.',
  'Août',
  'Sept.',
  'Oct.',
  'Nov.',
  'Déc.',
] as const;

export function monthLabel(month: string): string {
  const index = Number(month) - 1;
  return index >= 0 && index < MONTHS.length ? MONTHS[index] : '';
}

// Formate une date mois/année pour le texte envoyé à l'IA : « Janv. 2024 », « 2024 », ou ''.
export function formatMonthYear(value: MonthYear): string {
  const label = monthLabel(value.month);
  const year = value.year.trim();
  return [label, year].filter(Boolean).join(' ');
}
